import { render, staticRenderFns } from "./ngo-registration-form.vue?vue&type=template&id=a86beadc&scoped=true&"
import script from "./ngo-registration-form.vue?vue&type=script&lang=js&"
export * from "./ngo-registration-form.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registration-form.vue?vue&type=style&index=0&id=a86beadc&prod&lang=scss&scoped=true&"
import style1 from "./ngo-registration-form.vue?vue&type=style&index=1&id=a86beadc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86beadc",
  null
  
)

export default component.exports